import { isParticipantLayout2DViewActive } from "../layout/participant-layout/participant-layout-dom-state";

export function shouldSuppressIdleAutoExit({
  disableAutoExitOnIdle,
  disableIdleDetection,
  isStreaming,
  isWebcamShared,
  isScreenShared
} = {}) {
  return Boolean(
    disableAutoExitOnIdle ||
      disableIdleDetection ||
      isStreaming ||
      isWebcamShared ||
      isScreenShared ||
      isParticipantLayout2DViewActive()
  );
}
